<div class="success-block-container">
  <img src="/assets/icons/form-success.svg" alt="Success Icon" />
  <div class="success-text-container">
    <h5><ng-content></ng-content></h5>
  </div>
</div>
